import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideo2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVideo2"><Path d="M17.5 19.5H2V4.5H17.5V19.5Z" fill="currentColor"/><Path d="M22.5 17.6074L18.5 16.0078V7.99219L22.5 6.39258V17.6074Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideo2;
